import React, {Component} from 'react'
//import {TableComp} from 'sz-react-utils'
import _ from 'lodash'
import {Button, Drawer, Form, notification} from 'antd'
import Request from '../../../../request';
import {FormUtils as GetAllFormFields} from 'sz-react-utils'

import {connect} from 'react-redux'
import Moment from "moment"

@Form.create()

class ChangeBranch extends Component {
    state = {
        visible: true,
        modeArr: [],
        genderArr: [],
        maritalArr: [],
        countryFieldArr: [],
        phoneCodes: [],
        countryPhoneCodes: [],
        ifWhatsAppNumberIsDifferentSwitch: false
    }

    constructor(props) {
        super(props)
    }

    async componentDidMount() {
        const { form } = this.props;
        await this.getAllSource()
        await this.getAllGenders()
        await this.getAllMaritalStatus();
        this.loadCountries();
        const doc = this.props.param;

        this.setState({
            ifWhatsAppNumberIsDifferentSwitch: doc.ifWhatsAppNumberIsDifferentSwitch,
        });
        form.setFieldsValue({
            studentName: doc.studentName,
            gender: doc.gender,
            maritalStatus: doc.maritalStatus,
            mode: doc.mode,
            addressCountryId: doc.addressCountryId,
            ifWhatsAppNumberIsDifferentSwitch: doc.ifWhatsAppNumberIsDifferentSwitch,
            countryCode: doc.countryCode,
            location: doc.location,
            mobile: doc.mobile ? parseInt(doc.mobile) : null,
            emailId: doc.emailId,
            watsupp: doc.watsupp ? parseInt(doc.watsupp) : null,
            dateOfBirth: Moment(doc.dateOfBirth),
            passport: doc && doc.profile ? doc.profile.passportNumber : "",
        });
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        const {dispatch, form} = this.props;
        const {_id} = this.props.param;

        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let formData = {
                    valData,
                    _id,
                };
                
                let x = await Request.updateInquiry(formData);
                notification.success({
                    message: 'Student Quick Details Updated Successfully.'
                })
                this.onClose()
            }
        })
    }

    getAllSource = async() =>{
        let response  = await Request.getSourceDetails({
            results: 1000,
            count: 1000
        })
        let sourceObject = [];
        response.data && response.data.map((source)=>{
            sourceObject.push(source.sourceName)
        })
        this.setState({modeArr:sourceObject})
    }
    
    getAllGenders = async() =>{
      let response  = await Request.getGenderDetails({
        results: 1000,
        count: 1000
    })
      let genderObject = [];
      response.data && response.data.map((gender)=>{
        genderObject.push(gender.genderName)
      })
      this.setState({genderArr:genderObject})
    }
    
    getAllMaritalStatus = async()=>{
      let response  = await Request.getMaritalStatusDetails({
        results: 1000,
        count: 1000
      })
      let maritalObject = [];
        response.data && response.data.map((marital)=>{
          maritalObject.push(marital.maritalStatus)
        })
      this.setState({maritalArr:maritalObject})
    }

    loadCountries = () => {
        let params = {
          results: 100,
          sortField: "countryName",
          sortOrder: "ascend",
        };
        Request.getCountriesWithoutAuth({ ...params })
          .then((resp) => {
            let countryFieldArr = [];
            let phoneCodes = [];
            let countryPhoneCodes = [];
            resp.data = resp.data.reduce((temp, vv) => {
              countryFieldArr.push({ _id: vv._id, display: vv.countryName });
              if (vv.countryPhoneCode) {
                countryPhoneCodes[vv._id] = vv.countryPhoneCode;
                phoneCodes.push(vv.countryPhoneCode);
              }
              temp.push({ ...vv });
              return temp;
            }, []);
            this.setState({ countryFieldArr: countryFieldArr, phoneCodes: phoneCodes, countryPhoneCodes: countryPhoneCodes });
          })
          .catch((err) => {
            console.log(err);
          });
      };

    render() {

        const {
            form: {getFieldDecorator, getFieldValue, setFieldsValue}
        } = this.props

        let {
            modeArr,
            genderArr,
            maritalArr,
            countryFieldArr,
            phoneCodes,
            countryPhoneCodes
        } = this.state;
        const {studentName } = this.props.param;
        let inputTypes = {
            fields: [
                {
                    label: "Full Name as per passport ",
                    key: "studentName",
                    prefixComp: <h3>Basic Information As Per Passport </h3>,
                    required: true,
                },
                {
                    label: "Date Of Birth",
                    key: "dateOfBirth",
                    type: "date",
                    required: true,
                },
                {
                    label: "Gender",
                    key: "gender",
                    required: true,
                    type: "select",
                    defaultValue: "nfjw",
                    options: genderArr,
                    onChange: (v) => {
                      this.props.form.setFieldsValue({
                        gender: v,
                      });
                    },
                },
                {
                    label: "Marital Status",
                    key: "maritalStatus",
                    required: true,
                    type: "select",
                    defaultValue: "nfjw",
                    options: maritalArr,
                    onChange: (v) => {
                      this.props.form.setFieldsValue({
                        maritalStatus: v,
                      });
                    },
                },
                {
                    label: "How to come you know about us",
                    key: "mode",
                    type: "select",
                    showSearch: true,
                    options: modeArr,
                    onChange: (v) => {
                      this.props.form.setFieldsValue({ mode: v });
                    },
                },
                {
                    label: "Country",
                    key: "addressCountryId",
                    type: "select",
                    required: true,
                    showSearch: true,
                    defaultValue: "nfjw",
                    options: countryFieldArr,
                    onChange: (v) => {
                      if(countryPhoneCodes) {
                        let phoneCodeValue = (countryPhoneCodes[v] != undefined ? countryPhoneCodes[v] : '');
                        this.props.form.setFieldsValue({ countryCode: phoneCodeValue });
                      }
                      this.props.form.setFieldsValue({
                        addressCountryId: v,
                      });
                    },
                },
                {
                    label: "Country Code",
                    key: "countryCode",
                    type: "select",
                    required: true,
                    showSearch: true,
                    options: phoneCodes,
                    onChange: (v) => {
                      this.props.form.setFieldsValue({ countryCode: v });
                    },
                },
                {
                    label: "Mobile Number",
                    key: "mobile",
                    type: "number",
                    required: true,
                    style: { width: 190 },
                },
                {
                    label: 'If whats app number is different from Phone Number?',
                    key: 'ifWhatsAppNumberIsDifferentSwitch',
                    type: 'switch',
                    onChange: v => {
                      this.setState({ifWhatsAppNumberIsDifferentSwitch: v});
                      this.props.form.setFieldsValue({
                        ifWhatsAppNumberIsDifferentSwitch: v
                      })
                    }
                },       
                {
                    label: "Whatsapp Number",
                    hidden: (this.state.ifWhatsAppNumberIsDifferentSwitch == false),
                    required: (this.state.ifWhatsAppNumberIsDifferentSwitch == true),
                    key: "watsupp",
                    type: "number",
                    style: { width: 150 },
                },           
                { 
                    label: "Email Id ",
                    prefixComp: <p style={{fontSize:"10px", textAlign:"center", marginLeft:"130px"}}>If Email Id Doesn't Exist Add <b>noid@tenagents.com</b> </p>,
                    key: "emailId",
                    required:true 
                },
                {
                    label: "Passport",
                    key: "passport",
                    type: "text"
                },
            ]
        }
        return (
            <Drawer
                title={`Update Quick Details: ${studentName} `}
                placement="right"
                closable={true}
                onClose={() => this.onClose()}
                visible={this.state.visible}
                width={700}
            >
                <div>
                    <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>

                        <GetAllFormFields
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{marginBottom: 10, marginLeft: '33%'}}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                    </Form>

                </div>
            </Drawer>

        )
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangeBranch)
